import { render } from "./MainBlock.vue?vue&type=template&id=0974be4d"
import script from "./MainBlock.vue?vue&type=script&lang=js"
export * from "./MainBlock.vue?vue&type=script&lang=js"
script.render = render

export default script